/** Noun form for a count: 1 → singular, anything else (0, 2, 1.5) → plural. */
export function pluralize(count: number, singular: string, plural = `${singular}s`): string {
  return count === 1 ? singular : plural;
}
